/* Angular Stuff*/
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

/* Our Own Stuff*/
import { LangService } from "src/app/core/services/lang.service";
import { GridService } from "src/app/shared/services/grid.service";
import { DataLoadService } from "src/app/shared/services/data-load.service";

@Component({
  selector: "app-hr-employee-list2-unit",
  templateUrl:
    "./../../../templates/forms/modals/hr-employee-list2.component.html"
})
export class HrEmployeeList2Component implements OnInit {
  /**
   * TO CHANGE:
   * selector, templateUrl,
   * apiUrl, apiParams, gridId, modalTitle, colObj,
   *
   * &
   *
   * Add to core.module dec[] & entry[]
   */
  //

  apiUrl = "FG_HR_COMM_EMP3";
  apiParams = {};
  gridId = "HrEmployeeList2";
  modalTitle = this.langService.langData.employeeList;
  colObj = [];

  @Input()
  optionalParam: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  grid: any;
  columnDefs = [];

  tableList = [];

  constructor(
    private dataService: DataLoadService,
    public langService: LangService,
    public gridService: GridService
  ) {}

  ngOnInit() {
    this.setDefault();
  }

  setDefault() {
    this.colObj = [
      {
        headerName: this.langService.langData.employee,
        field: "EMP_NAME",
        sortable: true,
        resizable: true,
        hide: false
      }
    ];
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);

    this.apiParams = {
      P_BU_NO: this.optionalParam.P_BU_NO,
      P_JOBTITLE_NO: this.optionalParam.P_JOBTITLE_NO
    };
  }

  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.initTable();
  }

  initTable() {
    console.log("this.apiParams", this.apiParams) 
    if (this.apiParams) {
      this.dataService.load(this.apiUrl, this.apiParams).subscribe(results => {
        this.tableList = results.body;
      });
    } else {
      this.dataService.load(this.apiUrl).subscribe(results => {
        this.tableList = results.body;
      });
    }
    console.log("this.tableList:", this.tableList);
  }

  itemClick(_item) {
    this.modalShow = false;
    this.submit.next(_item);
  }
}
